import type { StakeholderRespondentType } from "../../graphql/generated/graphql";

/** 回答者種別の表示名。種別が増えたときに追加漏れを型で検知するため Record で持つ */
export const RESPONDENT_TYPE_LABELS: Record<StakeholderRespondentType, string> =
  {
    SUPERVISOR: "上司向け",
    SUBORDINATE: "部下向け",
    COLLEAGUE: "同僚向け",
    SELF: "本人",
  };

// 対象者ごとのシート複製はテンプレートのタブを複製する方式のため、シートを一意に特定できる
// gid 付きの URL でなければならない（バックエンドでも同じ形式を検証している）
const TEMPLATE_SHEET_URL_PATTERN =
  /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[A-Za-z0-9-_]+\/edit\?gid=\d+/;

export function isValidTemplateSheetUrl(url: string): boolean {
  return TEMPLATE_SHEET_URL_PATTERN.test(url);
}
